import { mockQuoteDetails, QuoteDetails } from '@domgen/dgx-fe-basket';

export const mockProtectionAdditionalQuotes: QuoteDetails[] = [
  { ...mockQuoteDetails, periodOfCover: 24 },
  { ...mockQuoteDetails, periodOfCover: 12 },
];
